import { Link, useParams } from "react-router-dom";
import { ArrowLeft, CalendarCheck2, MessageCircle } from "lucide-react";
import { BLOG_POSTS, CONTACT } from "@/data/siteData";
import { BLOG } from "@/constants/testIds";
import SEO from "@/components/SEO";
import { articleSchema } from "@/lib/schema";

export default function BlogPost() {
  const { slug } = useParams();
  const post = BLOG_POSTS.find((p) => p.slug === slug);
  const wa = `https://wa.me/39${CONTACT.whatsapp}`;

  if (!post) {
    return (
      <main className="pt-32 pb-24 max-w-3xl mx-auto px-6 text-center">
        <h1 className="font-serif text-4xl text-[#0B4A5A]">Articolo non trovato</h1>
        <Link to="/blog" className="btn-secondary mt-6 inline-flex">
          <ArrowLeft size={16} /> Blog
        </Link>
      </main>
    );
  }

  return (
    <main data-testid={BLOG.post} className="pt-28">
      <SEO
        title={post.title}
        description={post.excerpt}
        path={`/blog/${post.slug}`}
        image={post.image}
        type="article"
        jsonLd={articleSchema(post)}
      />
      <article>
        <div className="max-w-3xl mx-auto px-6 md:px-10 pt-8">
          <Link
            to="/blog"
            className="inline-flex items-center gap-2 text-sm text-gray-500 hover:text-[#0B4A5A] transition"
          >
            <ArrowLeft size={14} /> Tutti gli articoli
          </Link>
        </div>

        <header className="max-w-3xl mx-auto px-6 md:px-10 mt-8 mb-12">
          <div className="flex items-center gap-3 text-xs">
            <span className="uppercase tracking-[0.18em] text-[#C6A86B] font-medium">
              {post.category}
            </span>
            <span className="text-gray-400">·</span>
            <span className="text-gray-500">{post.date}</span>
            <span className="text-gray-400">·</span>
            <span className="text-gray-500">{post.readTime}</span>
          </div>
          <h1 className="font-serif text-4xl md:text-6xl mt-5 text-[#0B4A5A] leading-[1.05]">
            {post.title}
          </h1>
          <p className="mt-6 text-lg text-gray-600 leading-relaxed">{post.excerpt}</p>
        </header>

        <div className="max-w-5xl mx-auto px-6 md:px-10">
          <div className="rounded-2xl overflow-hidden aspect-[16/9]">
            <img
              src={post.image}
              alt={post.title}
              className="w-full h-full object-cover"
              loading="eager"
            />
          </div>
        </div>

        <div className="max-w-3xl mx-auto px-6 md:px-10 py-16 space-y-6 text-[17px] leading-[1.85] text-gray-800">
          {post.content.map((p, i) => (
            <p key={i}>{p}</p>
          ))}
        </div>

        <div className="max-w-3xl mx-auto px-6 md:px-10 pb-24">
          <div className="p-8 md:p-10 rounded-2xl bg-[#F9FAFB] border border-gray-100">
            <p className="overline">Prenota una visita</p>
            <h3 className="font-serif text-2xl md:text-3xl mt-3 text-[#0B4A5A]">
              Hai un sintomo che ti preoccupa?
            </h3>
            <p className="mt-3 text-gray-600">
              Prenota una visita specialistica per una valutazione clinica accurata.
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href={CONTACT.miodottore}
                target="_blank"
                rel="noopener noreferrer"
                className="btn-primary"
              >
                <CalendarCheck2 size={16} /> Prenota
              </a>
              <a
                href={wa}
                target="_blank"
                rel="noopener noreferrer"
                className="btn-secondary"
              >
                <MessageCircle size={16} /> WhatsApp
              </a>
            </div>
          </div>
        </div>
      </article>
    </main>
  );
}
